import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from "./pages/Home";
import RegistrationWithAdhar from "./pages/RegistrationWithAdhar";
import RegistrationWithAdharOTPVerify from "./pages/RegistrationWithAdharOTPVerify";
import CaptureImagePage from "./pages/registration/CaptureImagePage";
import PatientDetailsPage from "./pages/registration/PatientDetailsPage";
import BookConsultantPage from "./pages/registration/BookConsultantPage";
import MakePaymentPage from "./pages/registration/MakePaymentPage";
// import PaymentSuccess from "./pages/registration/PaymentSuccess";
import SessionEnd from "./pages/registration/SessionEnd";
import RegistrationSuccess from "./pages/RegistrationSuccess"; // NEW: Registration success page
import Login from "./pages/patient/Login";
import VerifyOTP from "./pages/patient/VerifyOTP";
import SelectPatientProfile from "./pages/patient/SelectPatientProfile";
import SelectExternalPatient from "./pages/patient/SelectExternalPatient";
import Dashboard from "./pages/patient/Dashboard";
import LabReports from "./pages/patient/LabReports";
import RadiologyReports from "./pages/patient/RadiologyReports";
import BookConsultation from "./pages/patient/BookConsultation";
import OpdVisitSuccess from "./pages/patient/OpdVisitSuccess";
import OPDCheckIn from "./pages/patient/OPDCheckIn";
import BookAppointment from "./pages/patient/BookAppointment";
import Billing from "./pages/patient/Billing";
import PatientMakePaymentPage from "./pages/patient/PatientMakePaymentPage";
import Faqs from "./pages/Faqs";
import ProtectedRoute from "./components/ProtectedRoute";
import OpdSchedule from "./pages/OpdSchedule";
import OnlinePayment from "./pages/OnlinePayment";
import OnlineDeposit from "./pages/OnlineDeposit";

import AppointmentReceipt from "./components/CounsaltantReceipt";
import CounsaltantReceipt from "./components/CounsaltantReceipt";

import PaymentSuccess from './components/PaymentSuccess';
import PaymentFailure from './components/PaymentFailure';
import PaymentCancel from './components/PaymentCancel';
import PaymentCallback from "./components/PaymentCallback";
import ServicePaymentSuccessPage from './components/ServicePaymentSuccessPage';
import AppointmentPaymentSuccess from './components/AppointmentPaymentSuccess';
import DepositPaymentSuccess from './pages/DepositPaymentSuccess';
import DepositPaymentFailure from './pages/DepositPaymentFailure';

import OnlinePaymentLink from "./pages/OnlinePaymentLink";
import PaymentHistory from "./pages/PaymentHistory";
import PaymentStatusChecker from "./pages/PaymentStatusChecker";
import KioskMachineManager from "./pages/admin/KioskMachineManager";
import axios from "axios";
import { jwtDecode } from 'jwt-decode';

function App() {

    useEffect(() => {
        const getToken = async () => {
            try {
                console.log("🔄 Fetching fresh token...");

                const res = await axios.post("https://kioskbe.kimsbbsr.co.in/kcore-ops/validateUserPassword?userName=admin&password=$$Kims@21");
                const newToken = res.data.tokenNo || "";
                const newDepartmentId = res.data.departmentId || "";

                console.log("✅ Fresh token fetched successfully:", newToken);

                localStorage.setItem("token", newToken);
                localStorage.setItem("departmentId", newDepartmentId);

                console.log("✅ Token stored successfully");
                console.log("Token:", newToken.substring(0, 50) + "...");

                // Decode and show token expiry
                try {
                    const decoded = jwtDecode(newToken);
                    if (decoded.exp) {
                        console.log("🕐 Token expires at:", new Date(decoded.exp * 1000).toLocaleString());
                    }
                } catch (e) {
                    console.log("Could not decode token");
                }
            } catch (error) {
                console.error("❌ Error fetching token:", error);
            }
        };

        getToken();
    }, []);

    return (
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/opd-schedule" element={<OpdSchedule />} />
                <Route path="/registration-with-adhar" element={<RegistrationWithAdhar />} />
                <Route path="/registration-with-adhar-otp-verify" element={<RegistrationWithAdharOTPVerify />} />
                <Route path="/capture-patient-image" element={<CaptureImagePage />} />
                <Route path="/patient-details" element={<PatientDetailsPage />} />
                <Route path="/registration-success" element={<RegistrationSuccess />} />
                <Route path="/verify-payment" element={<PaymentCallback />} />

                <Route path="/online-payment" element={<OnlinePayment />} />
                <Route path="/online-deposit" element={<OnlineDeposit />} />
                <Route path="/service-payment-success" element={<ServicePaymentSuccessPage />} />
                <Route path="/deposit-payment-success" element={<DepositPaymentSuccess />} />
                <Route path="/deposit-payment-failure" element={<DepositPaymentFailure />} />
                <Route path="/pay" element={<OnlinePaymentLink />} />
                <Route path="/payment-history" element={<PaymentHistory />} />
                <Route path="/payment-history/:mrno" element={<PaymentHistory />} />
                <Route path="/payment-status-checker" element={<PaymentStatusChecker />} />

                <Route path="/book-consultant" element={<BookConsultantPage />} />
                <Route path="/make-payment" element={<MakePaymentPage />} />
                {/* <Route path="/payment-success" element={<PaymentSuccess />} /> */}
                <Route path="/session-end" element={<SessionEnd />} />
                <Route path="/consultant-receipt" element={<CounsaltantReceipt />} />

                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/payment-failure" element={<PaymentFailure />} />
                <Route path="/payment-cancel" element={<PaymentCancel />} />
                <Route path="/appointment-success" element={<AppointmentPaymentSuccess />} />

                <Route path="/login" element={<Login />} />
                <Route path="/verify-otp" element={<VerifyOTP />} />


                {/* <Route path="/select-patient-profile" element={<ProtectedRoute><SelectPatientProfile /></ProtectedRoute>} /> */}
                <Route path="/select-patient-profile" element={<SelectPatientProfile />} />
                <Route path="/select-external-patient" element={<SelectExternalPatient />} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/opd-check-in" element={<ProtectedRoute><OPDCheckIn /></ProtectedRoute>} />
                <Route path="/book-appointment" element={<ProtectedRoute><BookAppointment /></ProtectedRoute>} />
                <Route path="/patient-make-payment-page" element={<ProtectedRoute><PatientMakePaymentPage /></ProtectedRoute>} />
                <Route path="/book-consultation" element={<ProtectedRoute><BookConsultation /></ProtectedRoute>} />
                <Route path="/opd-visit-success" element={<ProtectedRoute><OpdVisitSuccess /></ProtectedRoute>} />
                <Route path="/lab-reports" element={<ProtectedRoute><LabReports /></ProtectedRoute>} />
                <Route path="/radiology-reports" element={<ProtectedRoute><RadiologyReports /></ProtectedRoute>} />
                <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />

                {/* Admin Routes */}
                <Route path="/admin/kiosk-machines" element={<KioskMachineManager />} />

                <Route path="/faqs" element={<Faqs />} />
            </Routes>
        </Router>
    );
}

export default App;
